import createIcon from '../../createIcon';

/**
 * @component @name SortingUp
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMi4yNSA5SDguMjVWMTFIMi4yNVY5Wk0yLjI1IDIxVjE5SDE4Ljc1VjIxSDIuMjVaTTIuMjUgMTRIMTIuNzVWMTZIMi4yNVYxNFoiIGZpbGw9IiMxNjE2MTYiLz4KPHBhdGggZD0iTTIxLjc1IDcuOTk5OTdMMjAuMjY5NCA5LjQwOTk4TDE3LjU1MDMgNi44Mjk5N1YxNkgxNS40NTAyVjYuODI5OTdMMTIuNzMwNiA5LjQwOTk4TDExLjI1IDcuOTk5OTdMMTYuNTAwMiAyLjk5OTk3TDIxLjc1IDcuOTk5OTdaIiBmaWxsPSIjMTYxNjE2Ii8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SortingUp = createIcon('SortingUp', [
  [
    'path',
    {
      d: 'M2.25 9H8.25V11H2.25V9ZM2.25 21V19H18.75V21H2.25ZM2.25 14H12.75V16H2.25V14Z',
      key: 'k5y7ic',
    },
  ],
  [
    'path',
    {
      d: 'M21.75 7.99997L20.2694 9.40998L17.5503 6.82997V16H15.4502V6.82997L12.7306 9.40998L11.25 7.99997L16.5002 2.99997L21.75 7.99997Z',
      key: 'iqstit',
    },
  ],
]);

export default SortingUp;
